/* eslint-disable no-underscore-dangle */
import React, { useRef, memo } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import MatTable from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Switch from '@material-ui/core/Switch';

import TableHead from './TableHead';
import useStyles from './styles';
import { formatDate } from '../../../utils/date';
import { Order, isSelected } from '../../../utils/table';
import Checkbox from '../../../components/CustomCheckbox';
import CustomTableScroll from '../../../components/CustomTableScroll';
import {
  DeviceType,
} from '../../../types/Devices';


type Props = {
  order: Order;
  orderBy: string;
  devices:DeviceType[];
  onRowClick: (id: DeviceType['serial_number']) => void;
  onSelect: (event: React.SyntheticEvent, id: DeviceType['id']) => void;
  selected: Array<DeviceType['id']>;
  onSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOrder: (order: Order, orderBy: string) => void;
  onAdcDisarmUnlockChange: (id: DeviceType['id'], enabled: boolean) => void;
  updatingAdcDisarmUnlockId: DeviceType['id'] | null;
};

const Table: React.FC<Props> = props => {
  const classes = useStyles();
  const {
    devices, onChangeOrder, order, orderBy,
    onRowClick, onSelect, selected, onSelectAll,
    onAdcDisarmUnlockChange, updatingAdcDisarmUnlockId,
  } = props;
  const tableContainer = useRef<HTMLDivElement>(null);

  function handleRequestSort(
    event: React.SyntheticEvent,
    lock: string,
  ) {
    event.preventDefault();
    const isDesc = orderBy === lock && order === 'desc';
    onChangeOrder(isDesc ? 'asc' : 'desc', lock);
  }

  return (
    <TableContainer ref={tableContainer} className={classes.tableContainer}>
      <CustomTableScroll getTableContainer={() => tableContainer} columns={19} />
      <MatTable className={classes.tableRoot}>
        <TableHead
          order={order}
          orderBy={orderBy}
          rowCount={devices?.length}
          numSelected={devices.filter(device => isSelected(device.id, selected)).length}
          onRequestSort={handleRequestSort}
          onSelectAllClick={onSelectAll}
        />
        <TableBody>
          {devices.map((device, index) => {
            const isItemSelected: boolean = isSelected(device.id, selected);
            return (
              <TableRow
                hover
                role="checkbox"
                classes={{ root: classes.rowRoot }}
                key={device.id}
                tabIndex={-1}
                onClick={event => { event.stopPropagation(); onRowClick(device.serial_number); }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isItemSelected}
                    // inputProps={{ 'aria-labelledby': labelId }}
                    onClick={event => {
                      event.stopPropagation();
                      onSelect(event, device.id);
                    }}
                  />
                </TableCell>
                <TableCell align="center">{device.serial_number}</TableCell>
                <TableCell align="center">{device.builder?.name}</TableCell>
                <TableCell align="center">{device.hub_account?.username}</TableCell>
                <TableCell align="center">{device.property_id}</TableCell>
                <TableCell align="center">{device.hub_type}</TableCell>
                <TableCell align="center">{device.comments}</TableCell>
                <TableCell align="center">{device.created_on ? formatDate(device.created_on) : ''}</TableCell>
                <TableCell align="center">{device.created_by}</TableCell>
                <TableCell align="center">{device.modified_on ? formatDate(device.modified_on) : ''}</TableCell>
                <TableCell align="center">{device.modified_by}</TableCell>
                <TableCell
                  align="center"
                  onClick={event => event.stopPropagation()}
                >
                  {device.hub_type === 'ADC' && (
                    <Switch
                      checked={device.adc_disarm_unlock_enabled}
                      color="primary"
                      disabled={updatingAdcDisarmUnlockId === device.id}
                      inputProps={{ 'aria-label': `Disarm & Unlock for ${device.serial_number}` }}
                      onChange={event => onAdcDisarmUnlockChange(
                        device.id,
                        event.target.checked,
                      )}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>

      </MatTable>
    </TableContainer>
  );
};

export default memo(Table);
